module.exports = __webpack_public_path__ + "img/banner_pt.781587a2.jpg";